const c = {
  delay: 250,
  maxTry: 20
};
function y(t = c.delay) {
  return new Promise((r) => setTimeout(r, t));
}
const l = (t) => () => new Promise((r, e) => {
  try {
    r(t());
  } catch (n) {
    e(n);
  }
});
async function o(t, r = {}) {
  const { delay: e, maxTry: n } = { ...c, ...r }, s = () => n > 1, i = async () => (await y(e), await o(t, { delay: e, maxTry: n - 1 }));
  try {
    return await t();
  } catch (a) {
    if (s())
      return await i();
    throw console.error(
      "Function",
      t,
      "did not complete within allowed number of attempts:",
      a
    ), a;
  }
}
async function u(t, r = {}) {
  const e = l(t);
  return await o(e, r);
}
export {
  u as retry,
  o as retryAsync
};
